import { Empty, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import DeviceDetailsCard from "../components/devices/device-details-card/DeviceDetailsCard";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  createDevice,
  createDeviceClear,
  getDeviceList,
  updateDevice,
  updateDeviceClear,
} from "@src/redux";
import toast from "react-hot-toast";

interface Device {
  id?: string;
  name?: string;
  image?: string;
  referenceId?: string;
  macAddress?: string;
  brand?: {
    name?: string;
  };
  kitName?: string;
}

const Devices: React.FC = () => {
  const [deviceList, setDeviceList] = useState<Device[]>([]);

  const dispatch = useDispatch<AppDispatch>();
  const getAllDevice = useSelector(getDeviceList);
  const { loading: getDeviceListLoading } = useSelector(getDeviceList);
  const { result: updateDeviceDetails } = useSelector(updateDevice);
  const { result: createDeviceDetail } = useSelector(createDevice);

  useEffect(() => {
    if (getAllDevice?.result) {
      const allDevices =
        getAllDevice.result.items?.map((item: any) => ({
          id: item?.id,
          referenceId: item?.referenceId,
          macAddress: item?.macAddress,
          image: item?.image,
          name: item?.name,
          brand: item?.brand
            ? { ...item.brand, deviceType: item?.type }
            : null,
          kitName: item?.kitDevice?.kit?.referenceId,
        })) || [];

      setDeviceList(allDevices);
    } else {
      setDeviceList([]);
    }
  }, [getAllDevice]);

  useEffect(() => {
    if (createDeviceDetail?.status === "success") {
      toast.success("Device Created Successfully");
      dispatch(createDeviceClear());
    } else if (createDeviceDetail?.error?.message) {
      toast.error(createDeviceDetail?.error?.message);
      dispatch(createDeviceClear());
    } else if (updateDeviceDetails?.status === "success") {
      toast.success("Device Updated Successfully");
      dispatch(updateDeviceClear());
    } else if (updateDeviceDetails?.error?.message) {
      toast.error(updateDeviceDetails?.error?.message);
      dispatch(updateDeviceClear());
    }
  }, [createDeviceDetail, updateDeviceDetails]);

  const renderSkeleton = () => (
    <div className="device-list">
      {Array.from({ length: 8 }).map((_, idx) => (
        <div className="device-card device-card--skeleton" key={idx}>
          <div className="device-card-gradient-top" />
          <div className="device-image-container">
            <div className="device-image-halo device-image-halo--skeleton" />
          </div>
          <div className="device-info">
            <Skeleton
              active
              paragraph={{ rows: 2, width: ["80%", "60%"] }}
              title={{ width: "70%" }}
            />
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="device-page-wrapper">
      {getDeviceListLoading ? (
        renderSkeleton()
      ) : deviceList?.length > 0 ? (
        <div className="device-list">
          {deviceList.map((device: any) => (
            <DeviceDetailsCard key={device.id} device={device} />
          ))}
        </div>
      ) : (
        <div className="device-empty-wrapper">
          <Empty
            description={
              <span className="device-empty-text">No devices found</span>
            }
            className="no_device_found"
          />
        </div>
      )}
    </div>
  );
};

export default Devices;
